import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';
import { BroadcastFrameExample } from '@app/types/api';

interface fetchBroadcastsExamplesProps {
    mediaUploadName: string;
    contentDate: string;
    rightsholderId: number;
    sponsorId: number;
    placementId: number;
    clientId: number;
    useRightsholderAttribution?: boolean;
}

const fetchBroadcastsExamples = async ({
    mediaUploadName,
    contentDate,
    rightsholderId,
    sponsorId,
    placementId,
    clientId,
    useRightsholderAttribution = false,
}: fetchBroadcastsExamplesProps): Promise<BroadcastFrameExample[]> => {
    const response = await sportsApi
        .url('/media-uploads/broadcasts/examples')
        .query({
            mediaUploadName,
            contentDate,
            rightsholderId,
            sponsorId,
            placementId,
            clientId,
            ...(useRightsholderAttribution
                ? { useRightsholderAttribution: true }
                : {}),
        })
        .get()
        .json();

    return (response as (string | BroadcastFrameExample)[]).map(example =>
        typeof example === 'string'
            ? {
                  frameId: 0,
                  frameUrl: example,
                  capturedAt: null,
                  exposureStartAt: null,
                  exposureEndAt: null,
                  broadcastDuration: null,
                  frameWidth: null,
                  frameHeight: null,
                  boxes: [],
              }
            : example,
    );
};

const useBroadcastsExamples = ({
    mediaUploadName,
    contentDate,
    rightsholderId,
    sponsorId,
    placementId,
    clientId,
    useRightsholderAttribution = false,
    enabled = true,
}: fetchBroadcastsExamplesProps & { enabled?: boolean }) => {
    return useQuery(
        [
            'MediaUploadKey-broadcasts-examples',
            mediaUploadName,
            contentDate,
            rightsholderId,
            sponsorId,
            placementId,
            clientId,
            useRightsholderAttribution,
        ],
        () =>
            fetchBroadcastsExamples({
                mediaUploadName,
                contentDate,
                rightsholderId,
                sponsorId,
                placementId,
                clientId,
                useRightsholderAttribution,
            }),
        { enabled },
    );
};

export default useBroadcastsExamples;
